import range from 'lodash/range';
import isEmpty from 'lodash/isEmpty';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { cancelIconsChanges, discardIcons, fetchIcons, uploadIcon } from 'app/actions/manage-icons.actions';
import { checkAccess } from 'app/actions/app.actions';
import template from 'app/components/home/management/components/widgets/widgets-edit.html';
import { fetchWidgets, addWidget, updateWidget } from 'app/actions/widgets.actions';
import { DIRTY_FORM as DIRTY_FORM_MANAGEMENT } from 'app/components/home/management/components/widgets/widgets-management-component';

const DIRTY_FORM = 'widgetManagementEdit';

const mapStateToThis = ({ session, config, ui, manageIcons, widgets, dirtyForms }) => {
  const { locale } = session;
  const { locales, urlPattern, urlPatternError, secondHandApproval, widgetTitleMaxLength, widgetSubtitleMaxLength, ckeditor } = config;
  const { selectedLanguage } = ui;
  const { iconsApprovalStatus, entries, error, notification, isFileUploading } = manageIcons;
  const { copyItems, isLoading } = widgets;

  return {
    locale,
    locales,
    selectedLanguage,
    iconsApprovalStatus,
    entries,
    error,
    notification,
    isFileUploading,
    dirtyForm: dirtyForms[DIRTY_FORM],
    urlPattern,
    urlPatternError,
    secondHandApproval,
    widgetTitleMaxLength,
    widgetSubtitleMaxLength,
    ckeditor,
    copyItems,
    isLoading,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  uploadIcon,
  fetchIcons,
  cancelIconsChanges,
  discardIcons,
  checkAccess,
  fetchWidgets,
  updateWidget,
  addWidget,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', '$scope', 'gettextCatalog', '$sce', 'Notifications', '$timeout')
class WidgetsEditController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.DIRTY_FORM = DIRTY_FORM;
    this.DIRTY_FORM_MANAGEMENT = DIRTY_FORM_MANAGEMENT;
  }

  async $onInit() {
    this.index = this.$state.params.id;
    this.urlPattern = new RegExp(`^${this.urlPattern}$`);
    this.urlPatternError = this.urlPatternError.find((urlPatternError) => urlPatternError.code === this.selectedLanguage);
    this.moreButtonOptions = this.getMoreLabels();
    await this.initIcons();
    await this.initWidget();
    this.setDirtyForm(this.DIRTY_FORM, false);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async initIcons() {
    this.icons = this.generateIcons();
    const fetchOnlyApprovedIcons = true;
    await this.fetchIcons(fetchOnlyApprovedIcons);
  }

  async initWidget() {
    this.widget = {
      fields: this.locales.reduce((reduced, currentValue) => {
        reduced[currentValue.code] = { isNew: true };
        return reduced;
      }, {}),
      attachments: {},
    };
    if (this.index) {
      if (isEmpty(this.copyItems)) await this.fetchWidgets();
      this.widget = this.copyItems[this.index];
    }
  }

  ckeditorReady() {
    this.$timeout(() => this.setDirtyForm(this.DIRTY_FORM, false));
  }

  // eslint-disable-next-line class-methods-use-this
  generateIcons() {
    return range(1, 36).reduce((items, item) => items.concat(`icon-${item}.jpg`), []);
  }

  getMoreLabels() {
    return [
      {
        text: '',
      },
      {
        text: this.gettextCatalog.getString('Apply Now'),
      },
      {
        text: this.gettextCatalog.getString('Find out More'),
      },
      {
        text: this.gettextCatalog.getString('Get Details'),
      },
      {
        text: this.gettextCatalog.getString('Get Started'),
      },
      {
        text: this.gettextCatalog.getString('Learn How'),
      },
      {
        text: this.gettextCatalog.getString('Learn More'),
      },
      {
        text: this.gettextCatalog.getString('More Tips'),
      },
      {
        text: this.gettextCatalog.getString('More Tools'),
      },
      {
        text: this.gettextCatalog.getString('Read More'),
      },
      {
        text: this.gettextCatalog.getString('Sign up Now'),
      },
      {
        text: this.gettextCatalog.getString('View Images'),
      },
      {
        text: this.gettextCatalog.getString('Watch Video'),
      },
    ];
  }

  selectIcon(language, icon) {
    this.setDirtyForm(this.DIRTY_FORM, true);
    this.widget.fields[language].icon = icon;
  }

  prepareOptions() {
    return { ...this.ckeditor, extraPlugins: 'autogrow,emailVariables,wordcount,notification' };
  }

  showAlertSuccess(action) {
    this.Notifications.alertSuccess(this.gettextCatalog.getString(`Widget has been ${action === 'update' ? 'updated' : 'created'}`));
  }

  saveWidget(form) {
    form.$setSubmitted();
    if (form.$valid) {
      if (this.index) {
        this.updateWidget(this.index, this.widget);
        this.showAlertSuccess('update');
      } else {
        this.addWidget(this.widget);
        this.showAlertSuccess('add');
      }
      this.setDirtyForm(this.DIRTY_FORM, false);
      this.setDirtyForm(this.DIRTY_FORM_MANAGEMENT, true);
      this.$state.go('cms-widgetsManagement', {
        skipDirtyForms: true,
        skipReloadData: true,
      });
    }
  }

  setEntries(locale) {
    this.urlPatternError = this.urlPatternError.find((urlPatternError) => urlPatternError.code === locale);
    const key = Object.keys(this.widget.fields).find((localeKey) => localeKey === locale);
    if (!key) {
      this.widget.fields[locale] = {};
    }
  }
}

export default class EditWidgetComponent {
  constructor() {
    this.controller = WidgetsEditController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/widgets/widgets-edit-component.js